import React from 'react';
import { FaCheckCircle, FaDesktop } from 'react-icons/fa';
import { CondicoesEspeciaisStatus, EMPREENDIMENTO_LANCAMENTO } from '~/constant';
import AuthStorage from '~/Utils/AuthStorage';

const formatarMoeda = (valor) =>
  valor != null
    ? valor.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
    : null;

const chaveMotivoAutorizacao = (motivo) => [
  motivo.tipo || '',
  motivo.codigo_ativo || '',
  motivo.descricao || '',
  motivo.valor_esperado || '',
  motivo.valor_efetuado || '',
].join('-');

const normalizarStatusCondicaoEspecial = (status) => {
  if (typeof status === 'number') return status;
  if (status == null || status === '') return null;
  if (!Number.isNaN(Number(status))) return Number(status);
  if (status === 'PendenteDiretoria') return CondicoesEspeciaisStatus.PendenteDiretoria;
  if (status === 'PendenteGerente') return CondicoesEspeciaisStatus.PendenteGerente;
  if (status === 'SolicitacaoAprovada') return CondicoesEspeciaisStatus.SolicitacaoAprovada;
  if (status === 'Contraproposta' || status === 'ContraProposta') return CondicoesEspeciaisStatus.Contraproposta;
  if (status === 'SolicitacaoRecusada') return CondicoesEspeciaisStatus.SolicitacaoRecusada;
  return null;
};

const statusCondicaoEspecialLabel = (status) => {
  const valorStatus = normalizarStatusCondicaoEspecial(status);
  if (valorStatus === CondicoesEspeciaisStatus.PendenteDiretoria) return 'Pendente Diretoria';
  if (valorStatus === CondicoesEspeciaisStatus.PendenteGerente) return 'Pendente Gerente';
  if (valorStatus === CondicoesEspeciaisStatus.SolicitacaoAprovada) return 'Aprovada';
  if (valorStatus === CondicoesEspeciaisStatus.Contraproposta) return 'Contraproposta';
  if (valorStatus === CondicoesEspeciaisStatus.SolicitacaoRecusada) return 'Recusada';
  return 'Registrada';
};

const statusCondicaoEspecialVariant = (status) => {
  const valorStatus = normalizarStatusCondicaoEspecial(status);
  if (valorStatus === CondicoesEspeciaisStatus.SolicitacaoAprovada) return 'success';
  if (valorStatus === CondicoesEspeciaisStatus.SolicitacaoRecusada) return 'danger';
  return 'warning';
};

// URLV1 (Navbar/links) é calculado no import a partir SÓ do hostname — em localhost
// cai no fallback 'prod', então o link da PreVendaPropostaRapida apontava pra produção
// mesmo quando o user estava logado em HML/dev. Aqui resolvemos o env real via JWT
// (AuthStorage.getEnv) quando rodando localmente, garantindo que o link aponte pra
// mesma DB onde a venda foi gravada.
const URLS_SISTEMA_V1 = {
  prod: 'https://www.revobrasil.com.br/Extranet',
  hml: 'https://hml.revobrasil.com.br/Extranet',
  dev: 'https://dev.revobrasil.com.br/Extranet',
};
const obterUrlSistemaV1 = () => {
  const hostname = typeof window !== 'undefined' ? window.location.hostname : '';
  let env;
  if (hostname.includes('hml')) env = 'hml';
  else if (hostname.includes('dev')) env = 'dev';
  else if (hostname === 'localhost') env = AuthStorage.getEnv() || 'hml';
  else env = 'prod';
  return URLS_SISTEMA_V1[env] || URLS_SISTEMA_V1.hml;
};

const VendaGravada = ({ vendaGravada, codigoProspecto }) => {
  const color = vendaGravada.efetivada ? '#28A745' : '#FFC107';
  const isLancamento = AuthStorage.isAtendenteLancamento();
  const mapaHref = isLancamento && EMPREENDIMENTO_LANCAMENTO
    ? `/mapa/${EMPREENDIMENTO_LANCAMENTO}`
    : '/mapa';
  const motivos = vendaGravada.motivos_autorizacao || [];
  const urlSistemaV1 = obterUrlSistemaV1();
  const codigoSolicitacaoDesconto = vendaGravada.codigo_solicitacao_desconto
    || vendaGravada.codigoSolicitacaoDesconto;
  const statusCondicaoEspecial = vendaGravada.status_condicao_especial
    || vendaGravada.statusCondicaoEspecial;

  return (
    <div className="text-center">
      <FaCheckCircle color={color} fontSize={72} />
      <h4>
        Venda{' '}
        <span style={{ color: color }}>
          {vendaGravada.efetivada ? 'Realizada' : 'Gravada para Aprovação'}
        </span>
        !
      </h4>
      {!vendaGravada.efetivada && motivos.length > 0 && (
        <div className="alert alert-warning text-left mt-2">
          <strong>Motivos que requerem aprovação:</strong>
          <ul className="mb-0 mt-1">
            {motivos.map(m => (
              <li key={chaveMotivoAutorizacao(m)}>
                {m.descricao}
                {m.valor_esperado != null && m.valor_efetuado != null && (
                  <span className="text-muted ml-1">
                    (esperado: {formatarMoeda(m.valor_esperado)} / efetuado: {formatarMoeda(m.valor_efetuado)})
                  </span>
                )}
              </li>
            ))}
          </ul>
        </div>
      )}
      {codigoSolicitacaoDesconto && (
        <div className={'alert alert-' + statusCondicaoEspecialVariant(statusCondicaoEspecial) + ' text-left mt-2'}>
          <strong>Solicitação de desconto #{codigoSolicitacaoDesconto}</strong>
          <span className="ml-1">
            {statusCondicaoEspecialLabel(statusCondicaoEspecial)}
          </span>
        </div>
      )}
      <div className="row">
        <div className="col-md-12">
          <h4>Proposta: {vendaGravada.codigo_proposta}</h4>
          {vendaGravada.codigos_pre_vendas &&
            vendaGravada.codigos_pre_vendas.map(codigo => (
              <div className="text-center d-block" key={codigo}>
                <a
                  className="btn btn-outline-primary"
                  target="blank"
                  href={`${urlSistemaV1}/Comercial/PreVendaPropostaRapida.aspx?PreVenda=${codigo}`}
                >
                  Ver proposta da Pré-venda - {codigo}
                </a>
              </div>
            ))}
        </div>
      </div>
      <div className="row mt-5">
        <div className="col-md-6">
          <a
            className="btn btn-outline-primary mr-3"
            href={`/AdministracaoVendas?codigo_proposta=${vendaGravada.codigo_proposta}${codigoProspecto ? '&codigo_prospecto=' + codigoProspecto : ''}`}
          >
            Administração de vendas
          </a>
        </div>
        <div className="col-md-6">
          <a
            className="btn btn-outline-primary ml-3"
            href={mapaHref}
          >
            Mapa do empreendimento
          </a>
        </div>
      </div>
      {isLancamento && (
        <div className="row mt-3">
          <div className="col-md-12">
            <a
              className="btn btn-primary"
              href="/lancamento/colaborador/atendimento"
            >
              <FaDesktop className="mr-1" />
              Voltar para Atendimento
            </a>
          </div>
        </div>
      )}
    </div>
  );
};

export default VendaGravada;
